const isDecember = () => new Date().getMonth() === 11;

const ChristmasFeatures = () => {
  if (!isDecember()) return null;
  const snowflakes = Array.from({ length: 80 });
  const icons = ["❄", "✨", "🎄", "🎁", "🎅"];
  return (
    <>
      {/* Santa */}
      <div className="santa">🎅</div>

      {/* Chrismas Navbar */}
      <div className="navbar navbar-expand-lg navbar-dark bg-dark position-relative pt-0 pb-0">
        {/* Christmas Lights */}
        <ul className="christmas-lights">
          {[...Array(20)].map((_, i) => (
            <li key={i}></li>
          ))}
        </ul>

        <div className="container-fluid d-flex justify-content-center alert alert-primary  text-center rounded-0 mb-0">
          {/* Banner */}
          <div className="">🎄 Merry Christmas & Happy Holidays! 🎁</div>
        </div>
      </div>

      {/* Snowflakes */}

      <div className="snow-container">
        {snowflakes.map((_, i) => {
          const style = {
            left: `${Math.random() * 100}vw`,
            animationDuration: `${8 + Math.random() * 12}s`,
            animationDelay: `${Math.random() * 5}s`,
            fontSize: `${10 + Math.random() * 20}px`,
            opacity: `${0.5 + Math.random() * 0.9}`,
          };

          return (
            <div key={i} className="snowflake" style={style}>
              {icons[Math.floor(Math.random() * icons.length)]}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ChristmasFeatures;
